import { get } from "lodash";
import { MdClose } from "react-icons/md";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import Button from "../../../../Button";

function View({ onSubmit, onClose, generalCost, upsells, totalAmount }) {
  const planName = get(generalCost, "insurancePlan.name") || "";
  const currency = get(generalCost, "currency");
  const currencySymbol = CURRENCY_SYMBOL[currency] || CURRENCY_SYMBOL.EUR;
  const annualAmount = (parseFloat(totalAmount) * 12).toFixed(2);

  return (
    <div className="miltis-cart-modal">
      {/* Plan name */}
      <div className="miltis-cart-modal__header">
        <h2 className="miltis-cart-modal__plan-name">{planName}</h2>
        {/* Price section */}
        <div className="miltis-cart-modal__price-section">
          <div className="miltis-cart-modal__price">
            <span className="miltis-cart-modal__price-value">
              {costToFrench(totalAmount)} {currencySymbol}
            </span>
            <span className="miltis-cart-modal__price-period">/mois</span>
          </div>
          <div className="miltis-cart-modal__price-annual">
            soit une cotisation de{" "}
            <strong>
              {costToFrench(annualAmount)} {currencySymbol}
            </strong>{" "}
            / an
          </div>
        </div>
      </div>

      <div className="miltis-cart-modal__divider" />

      {/* Upsells section */}
      {upsells.length > 0 && (
        <div className="miltis-cart-modal__upsells">
          <span className="miltis-cart-modal__upsells-label">
            Inclut dans le prix
          </span>
          <div className="miltis-cart-modal__upsells-list">
            {upsells.map(({ insurancePlan: { name }, cost, currency }) => (
              <div className="miltis-cart-modal__upsell-item" key={name}>
                <span className="miltis-cart-modal__upsell-name">{name}</span>
                <span className="miltis-cart-modal__upsell-price">
                  {costToFrench(cost)} {CURRENCY_SYMBOL[currency] || "€"} / mois
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Actions */}
      <div className="miltis-cart-modal__actions">
        <button
          type="button"
          className="miltis-cart-modal__close-btn"
          onClick={onClose}
        >
          <MdClose size={24} />
          <span>Fermer</span>
        </button>
        <Button type="primary" onClick={onSubmit} width="100%">
          Modifier
        </Button>
      </div>
    </div>
  );
}

export default View;
